import React from 'react';
import Api from '../utils/Api';
import Constants from '../constants';
import { ParseDateTime } from '../utils/Parser';

const CardTransaction = (props) => {

    const statusToColor = {
        'PROCESSING': 'color-yellow-orange',
        'COMPLETED': 'color-aqua-green',
        'PENDING': 'color-dark-sky-blue',
        'CANCELLED': 'color-pink-red',
    }

    const statusToBg = {
        'PROCESSING': 'rgba(245, 158, 11, 0.1)',
        'COMPLETED': 'rgba(39, 174, 96, 0.1)',
        'PENDING': 'rgba(38, 122, 182, 0.1)',
        'CANCELLED': 'rgba(192, 57, 43, 0.1)',
    }

    const statusToBorder = {
        'PROCESSING': 'rgba(245, 158, 11, 0.3)',
        'COMPLETED': 'rgba(39, 174, 96, 0.3)',
        'PENDING': 'rgba(38, 122, 182, 0.3)',
        'CANCELLED': 'rgba(192, 57, 43, 0.3)',
    }

    const statusToES = {
        'PROCESSING': 'Procesando',
        'COMPLETED': 'Completada',
        'PENDING': 'Pendiente',
        'CANCELLED': 'Cancelada',
    }

    const typeToES = {
        'DEPOSIT': 'Depósito',
        'WITHDRAWAL': 'Retiro',
    }

    const generateReceipt = () => {
        Api.fetchDownload(Constants.BACKEND_APIS.generateReceipt(), 'POST', `receipt_${props.uuid}`, {'txn': props.uuid})
    }

    const isDeposit = props.type === 'DEPOSIT';

    return (
        <div className='flex items-center gap-3 px-4 py-3 border-b' style={{borderColor: 'rgba(255,255,255,0.05)'}}>
            {/* Icon */}
            <div className='flex-shrink-0 w-9 h-9 rounded-full flex items-center justify-center' style={{background: isDeposit ? 'rgba(39, 174, 96, 0.12)' : 'rgba(192, 57, 43, 0.12)'}}>
                {isDeposit
                    ? <i className='bx bxs-down-arrow-alt text-lg color-aqua-green'></i>
                    : <i className='bx bxs-up-arrow-alt text-lg color-pink-red'></i>
                }
            </div>

            {/* Info */}
            <div className='flex-1 min-w-0'>
                <div className='flex items-center justify-between mb-0.5'>
                    <span className='text-sm font-semibold text-white'>{typeToES[props?.type]}</span>
                    <span className='text-sm font-bold text-white'>$ {props.amount}</span>
                </div>
                <div className='flex items-center justify-between'>
                    <span className='text-xs color-dark-sky-blue'><ParseDateTime date={props.date_created}/></span>
                    <span
                        className={`text-xs font-semibold px-2 py-0.5 rounded-full ${statusToColor[props.status]}`}
                        style={{background: statusToBg[props.status], border: `1px solid ${statusToBorder[props.status]}`}}
                    >
                        {statusToES[props.status]}
                    </span>
                </div>
                <div className='flex items-center justify-between mt-1'>
                    <span className='text-xs text-gray-500 truncate max-w-xs'>#{props.uuid?.slice(0, 8)}</span>
                    <button onClick={generateReceipt} className='flex items-center gap-1 text-xs text-gray-400 hover:text-white transition-colors duration-200'>
                        <i className='bx bxs-download text-sm color-dark-sky-blue'></i>
                        Comprobante
                    </button>
                </div>
            </div>
        </div>
    )
}

export default CardTransaction;
